import { del, get, post } from './apiClient.js'

// Normalize statement object: map cepInstance <-> instanceName for backward compatibility
const normalizeStatement = (statement) => {
  if (!statement) return statement

  return {
    ...statement,
    // API uses 'cepInstance', UI uses 'instanceName' - support both
    instanceName: statement.cepInstance || statement.instanceName,
    cepInstance: statement.cepInstance || statement.instanceName,
    // Ensure versions array exists (UI expects it even if empty)
    versions: statement.versions || [],
  }
}

export const listStatements = async (options = {}) => {
  const response = await get('statements', options)

  // Normalize all statements in response
  if (response && response.statements && Array.isArray(response.statements)) {
    return {
      ...response,
      statements: response.statements.map(normalizeStatement)
    }
  }

  return response
}

export const createStatement = (payload, options = {}) => {
  // Map instanceName -> cepInstance for API
  const normalized = {
    ...payload,
    cepInstance: payload.cepInstance || payload.instanceName,
  }

  // Remove instanceName to avoid confusion (API uses cepInstance)
  delete normalized.instanceName

  if (!normalized.outputKafkaTopic) {
    delete normalized.outputKafkaTopic
  }

  return post('statements', normalized, options).then(normalizeStatement)
}

export const validateStatement = async (payload, options = {}) => {
  // Map instanceName -> cepInstance for API
  const normalized = {
    ...payload,
    cepInstance: payload.cepInstance || payload.instanceName,
  }
  delete normalized.instanceName

  const response = await post('statements/validate', normalized, options)

  // Return the full validation response from backend
  // Backend returns: { valid, message, errors, warnings, validationType }
  return response
}

export const deleteStatement = (statementId, options = {}) =>
  del(`statements/${encodeURIComponent(statementId)}`, options)

export const fetchStatementVersions = async (statementId, options = {}) => {
  const response = await get(`statements/${encodeURIComponent(statementId)}`, options)
  return normalizeStatement(response)
}

export default {
  listStatements,
  createStatement,
  validateStatement,
  deleteStatement,
  fetchStatementVersions,
}
